import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDashboard } from '../../pages/dashboard/DashboardShell';

const PremiumGate = ({
  children,
  icon,
  iconColor = 'text-chess-green',
  title,
  description,
  benefits = [],
  benefitsTitle = 'Premium Features Include',
}) => {
  const { isPremium } = useDashboard();
  const navigate = useNavigate();

  if (isPremium) {
    return children;
  }

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <div className="bg-gray-800/50 border border-gray-700 rounded-2xl p-8 text-center">
        <div className={`w-20 h-20 ${iconColor === 'text-chess-green' ? 'bg-chess-green/20' : 'bg-current/20'} rounded-full flex items-center justify-center mx-auto mb-6`}
          style={iconColor !== 'text-chess-green' ? { backgroundColor: 'rgba(74, 222, 128, 0.2)' } : undefined}
        >
          <i className={`fa-solid ${icon} ${iconColor} text-3xl`}></i>
        </div>

        <h1 className="text-2xl font-bold text-white mb-3">{title}</h1>
        <p className="text-gray-400 mb-8 max-w-md mx-auto">{description}</p>

        {benefits.length > 0 && (
          <div className="bg-gray-900/50 border border-gray-700 rounded-xl p-6 mb-8 text-left">
            <h3 className="text-sm font-semibold text-gray-300 mb-4 uppercase tracking-wider text-center">
              {benefitsTitle}
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-center gap-3">
                  <i className={`fa-solid ${benefit.icon} text-chess-green text-sm w-5 text-center`}></i>
                  <span className="text-gray-300 text-sm">{benefit.text}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <button
          onClick={() => navigate('/dashboard/website/premium')}
          className="bg-yellow-500 hover:bg-yellow-400 text-gray-900 px-8 py-3 rounded-xl font-bold transition-colors inline-flex items-center gap-2"
        >
          <i className="fa-solid fa-crown"></i>
          Upgrade to Premium
        </button>
        <p className="text-gray-500 text-sm mt-3">
          Includes 14-day free trial
        </p>
      </div>
    </div>
  );
};

export default PremiumGate;
